<template>
  <div class="rule-page">
    <div class="rule-inner">
      <header class="rule-hero">
        <div class="rule-hero__accent" aria-hidden="true" />
        <h1 class="rule-hero__title">
          {{
            $store.state.language === 'en'
              ? 'Rules & regulations'
              : 'စည်းကမ်းချက်များ'
          }}
        </h1>
        <p class="rule-hero__subtitle">
          {{
            $store.state.language === 'en'
              ? 'Issued by ManDaLarThu. Please read each section carefully.'
              : 'မန္တလာသူ မှထုတ်ပြန်သော စည်းကမ်းချက်များ — အပိုင်းတစ်ခုချင်းစီကို သေချာဖတ်ရှုပါ။'
          }}
        </p>
      </header>

      <ol class="rule-list">
        <li class="rule-card">
          <span class="rule-card__num" aria-hidden="true">၁</span>
          <div class="rule-card__body">
            ဘော်ဒီများကိုအနည်းဆုံး (1000) ကျပ်မှ စတင်ပြီး ဆော့ကစားနိုင်ပါသည်။
          </div>
        </li>

        <li class="rule-card">
          <span class="rule-card__num" aria-hidden="true">၂</span>
          <div class="rule-card__body">
            <p class="rule-card__p">
              ပွဲစဉ်များကို ပွဲကြီး ပွဲသေး အရောင်နဲ့ ပိုင်းခြားပြပြီး အကောက်ကို 5% သာ ကောက်ခံပါသည်။
            </p>
            <p class="rule-card__label">{{ $store.state.language === 'en' ? 'Commission' : 'အကောက်' }}</p>
            <ul class="rule-card__subs">
              <li><strong class="rule-card__strong">ပွဲကြီး</strong> — 5%</li>
              <li><strong class="rule-card__strong">ပွဲသေး</strong> — 5%</li>
            </ul>
          </div>
        </li>

        <li class="rule-card">
          <span class="rule-card__num" aria-hidden="true">၃</span>
          <div class="rule-card__body">
            <p class="rule-card__p">
              မောင်း အနည်း ဆုံး (500) ကျပ်မှ ကစားနိုင်သည်။
            </p>
            <p class="rule-card__label">{{ $store.state.language === 'en' ? 'Maung commission' : 'မောင်းအကောက်' }}</p>
            <ul class="rule-card__subs">
              <li><strong class="rule-card__strong">2 သင်း</strong> — 15%</li>
              <li><strong class="rule-card__strong">3 သင်း – 11 သင်း</strong> — 20%</li>
            </ul>
          </div>
        </li>

        <li class="rule-card">
          <span class="rule-card__num" aria-hidden="true">၄</span>
          <div class="rule-card__body">
            <p class="rule-card__p">
              အနိုင် အရှုံး သရေ(1x2)၊ ဂိုးခန့်မှန်းရလဒ်(focus)တို့ကို အနည်းဆုံး(၁၀၀၀)ကျပ်မှ စတင်ကစားနိုင်ပါသည်။
            </p>
            <p class="rule-card__label">{{ $store.state.language === 'en' ? 'Commission' : 'အကောက်' }}</p>
            <ul class="rule-card__subs">
              <li><strong class="rule-card__strong">1x2</strong> — 5%</li>
              <li><strong class="rule-card__strong">Focus</strong> — 5%</li>
            </ul>
          </div>
        </li>

        <li class="rule-card">
          <span class="rule-card__num" aria-hidden="true">၅</span>
          <div class="rule-card__body">
            သက်မှတ်ချိန် တစ်ရက်တာအတွင်း ပွဲပျက်(သို့မဟုတ်) မကန်သောပွဲစဉ်များ ရလဒ်မထွက်သောပွဲစဉ်များအား အလျော်အစားမလုပ်ပဲ ထိုးငွေအား ပြန်ပေးပါမည်။
            <p class="rule-card__note">
              မှတ်ချက် — သက်မှတ်ပွဲစချိန်မှ 2 နာရီ အတွင်း မကန်သော အချို့ပွဲစဉ်များအား ပွဲပျက်ဟု သတ်မှတ်နိုင်သည်။
            </p>
          </div>
        </li>

        <li class="rule-card">
          <span class="rule-card__num" aria-hidden="true">၆</span>
          <div class="rule-card__body">
            အချိန်စောကန်သွားသော ပွဲစဉ်များအား မန္တလာသူ Application တွင်မူလအချိန်အတိုင်း အချိန်မပြောင်းပဲ ဖွင့်ထားပါက ပွဲပျက်သက်မှတ်ပါမည်။ အချိန်ပြောင်းလဲထားပါက အလျော်အစားပြုလုပ်ပါမည်။
          </div>
        </li>

        <li class="rule-card">
          <span class="rule-card__num" aria-hidden="true">၇</span>
          <div class="rule-card__body">
            ဂိုးရလဒ်များကို မြန်မာကြေးထွက်ရှိသော Betting Company မှဂိုးရလဒ်ဖြင့် အလျော်အစားပြုလုပ်ပါမည် ( Ibet789 / Bet365 )
          </div>
        </li>

        <li class="rule-card">
          <span class="rule-card__num" aria-hidden="true">၈</span>
          <div class="rule-card__body">
            နည်းပညာချွတ်ယွင်း၍ အခြားသော Betting Company များနှင့် ပေါက်ကြေးလွန်စွာကွဲလွဲနေပါက Cancel match ပြုလုပ်ပါမည်။
          </div>
        </li>

        <li class="rule-card">
          <span class="rule-card__num" aria-hidden="true">၉</span>
          <div class="rule-card__body">
            နည်းပညာချွတ်ယွင်း၍ အလျော်အစားမှားပြုလုပ်ထားသော ဘောင်ချာများအား နောက်တစ်နေ့ နေ့ခင်း 12 နာရီမတိုင်ခင် အကြောင်းကြားပေးထားသောဘောင်ချာများသာ တာဝန်ယူဖြေရှင်းပေးမည်။
          </div>
        </li>

        <li class="rule-card">
          <span class="rule-card__num" aria-hidden="true">၁၀</span>
          <div class="rule-card__body">
            ပုံမှန်မဟုတ်သော ပွဲစဉ်များပါရှိပါက ၎င်းပွဲစဉ်အား အလျော်အစားမပြုပဲ Cancel Match ပြုလုပ်ပါမည်။
          </div>
        </li>

        <li class="rule-card">
          <span class="rule-card__num" aria-hidden="true">၁၁</span>
          <div class="rule-card__body">
            ဆော့ကစားခြင်းမရှိပဲ ငွေ အထုတ်/အသွင်း ပြုလုပ်သော အကောင့်များအား ငွေပြန်မအမ်းပဲ ပိတ်သိမ်းပါမည်။
          </div>
        </li>

        <li class="rule-card">
          <span class="rule-card__num" aria-hidden="true">၁၂</span>
          <div class="rule-card__body">
            နည်းပညာအကူအညီဖြင့်သော်လည်းကောင်း၊ အခြားမရိုးသားသည့်နည်းလမ်းများကို အသုံးပြု၍ ကစားထားသည်များကို တွေ့ရှိရပါက ငွေပြန်ထုတ်ပေးခြင်းမရှိဘဲ ခြွင်းချက်မရှိ အကောင့်ပိတ်သိမ်းပါမည်။
          </div>
        </li>

        <li class="rule-card rule-card--last">
          <span class="rule-card__num" aria-hidden="true">၁၃</span>
          <div class="rule-card__body">
            အငြင်းပွါးဖွယ်ရာ ကိစ္စများပေါ်ပေါက်လာပါက အများနှင့်နိူင်းယှဉ်သုံးသပ်ရသည့်အတွတ် မန္တလာသူ ၏ ဆုံးဖြတ်ချက်သာအတည်ဖြစ်သည်။
          </div>
        </li>
      </ol>

      <div class="rule-ack" role="status">
        {{
          $store.state.language === 'en'
            ? 'Please confirm that you have read the rules and agree to them.'
            : 'စည်းကမ်းချက်များကို သေချာစွာဖတ်ရှုပြီး သဘောတူပါကြောင်း အတည်ပြုပေးပါ။'
        }}
      </div>

      <div class="rule-actions-spacer" aria-hidden="true" />
    </div>

    <div class="rule-actions">
      <div class="rule-actions__inner">
        <button
          type="button"
          class="rule-btn rule-btn--decline"
          @click="logout"
        >
          {{
            $store.state.language === 'en'
              ? 'I do not agree'
              : 'အတည်မပြုပါ'
          }}
        </button>
        <button
          type="button"
          class="rule-btn rule-btn--accept"
          @click="toHome"
        >
          {{
            $store.state.language === 'en'
              ? 'I agree'
              : 'အတည်ပြုပါသည်'
          }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';

export default {
  methods: {
    ...mapActions(['logoutUser']),
    async logout() {
      await this.logoutUser();
      this.$router.push('/auth/login');
    },
    toHome() {
      this.$router.push('/home');
    },
  },
};
</script>

<style scoped>
.rule-page {
  min-height: 100vh;
  padding: 1rem 0.75rem 0;
  padding-bottom: calc(5.5rem + env(safe-area-inset-bottom, 0px));
  background-color: #0d0e12;
  background-image: linear-gradient(180deg, rgba(13, 14, 18, 0.94) 0%, rgba(13, 14, 18, 0.9) 100%),
    url('https://storage.googleapis.com/spacetech2/mdl/bg.png');
  background-size: cover;
  background-position: center top;
  -webkit-overflow-scrolling: touch;
}

.rule-inner {
  margin: 0 auto;
  max-width: 32rem;
}

.rule-hero {
  margin-bottom: 1.25rem;
  padding: 0 0.15rem;
  position: relative;
  text-align: center;
}

.rule-hero__accent {
  background: linear-gradient(90deg, transparent, rgba(250, 230, 60, 0.45), transparent);
  height: 3px;
  margin: 0 auto 1rem;
  max-width: 6rem;
  border-radius: 2px;
}

.rule-hero__title {
  color: #faf3a8;
  font-size: 1.15rem;
  font-weight: 800;
  letter-spacing: 0.03em;
  line-height: 1.35;
  margin: 0 0 0.5rem;
  text-shadow: 0 0 24px rgba(250, 230, 60, 0.15);
}

.rule-hero__subtitle {
  color: #8b95a8;
  font-size: 0.78rem;
  font-weight: 500;
  line-height: 1.55;
  margin: 0;
}

.rule-list {
  counter-reset: rule-item;
  list-style: none;
  margin: 0;
  padding: 0;
}

.rule-card {
  align-items: flex-start;
  background: #1d1f26;
  border: none;
  border-radius: 14px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.28);
  display: flex;
  gap: 0.75rem;
  margin-bottom: 0.65rem;
  padding: 0.85rem 0.9rem;
  transition: box-shadow 0.15s ease;
}

.rule-card:hover {
  box-shadow: 0 8px 28px rgba(0, 0, 0, 0.32);
}

.rule-card--last {
  margin-bottom: 0;
}

.rule-card__num {
  align-items: center;
  background: linear-gradient(145deg, rgba(250, 230, 60, 0.28) 0%, rgba(250, 230, 60, 0.1) 100%);
  border: 1px solid rgba(250, 230, 60, 0.4);
  border-radius: 10px;
  color: #faf3a8;
  display: flex;
  flex-shrink: 0;
  font-size: 0.8rem;
  font-weight: 800;
  height: 2rem;
  justify-content: center;
  min-width: 2rem;
  padding: 0 0.35rem;
}

.rule-card__body {
  color: #c5cad6;
  flex: 1;
  font-size: 0.8125rem;
  line-height: 1.65;
  min-width: 0;
}

.rule-card__p {
  margin: 0 0 0.5rem;
}

.rule-card__p:last-child {
  margin-bottom: 0;
}

.rule-card__label {
  color: #faf3a8;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.04em;
  margin: 0.5rem 0 0.35rem;
  text-transform: uppercase;
}

.rule-card__subs {
  list-style: none;
  margin: 0;
  padding: 0;
}

.rule-card__subs li {
  border-left: 2px solid rgba(250, 230, 60, 0.35);
  color: #aeb6c5;
  font-size: 0.8rem;
  line-height: 1.5;
  margin-bottom: 0.35rem;
  padding-left: 0.65rem;
}

.rule-card__subs li:last-child {
  margin-bottom: 0;
}

.rule-card__strong {
  color: #e8eaef;
  font-weight: 700;
}

.rule-card__note {
  border-left: 2px solid rgba(250, 230, 60, 0.3);
  color: #8b95a8;
  font-size: 0.75rem;
  line-height: 1.55;
  margin: 0.65rem 0 0;
  padding-left: 0.65rem;
}

.rule-ack {
  background: rgba(250, 230, 60, 0.08);
  border: 1px solid rgba(250, 230, 60, 0.22);
  border-radius: 12px;
  color: #e8eaef;
  font-size: 0.8rem;
  font-weight: 600;
  line-height: 1.55;
  margin-top: 1.25rem;
  padding: 0.9rem 1rem;
  text-align: center;
}

.rule-actions-spacer {
  height: 0.5rem;
}

.rule-actions {
  background: linear-gradient(180deg, transparent 0%, rgba(13, 14, 18, 0.92) 35%, #0d0e12 100%);
  bottom: 0;
  left: 0;
  padding: 0.75rem 0.85rem calc(0.75rem + env(safe-area-inset-bottom, 0px));
  position: fixed;
  right: 0;
  z-index: 100;
}

.rule-actions__inner {
  display: flex;
  gap: 0.55rem;
  justify-content: center;
  margin: 0 auto;
  max-width: 32rem;
}

.rule-btn {
  -webkit-tap-highlight-color: transparent;
  border: none;
  border-radius: 12px;
  cursor: pointer;
  flex: 1;
  font-size: 0.8rem;
  font-weight: 700;
  max-width: 11rem;
  padding: 0.7rem 0.65rem;
  transition: filter 0.15s ease, transform 0.1s ease;
}

.rule-btn:active {
  transform: scale(0.98);
}

.rule-btn--decline {
  background: #2a1f24;
  border: 1px solid rgba(220, 53, 69, 0.45);
  color: #f5a5ad;
}

.rule-btn--decline:active {
  filter: brightness(1.08);
}

.rule-btn--accept {
  background: linear-gradient(180deg, #ffef5c 0%, #FAE63C 45%, #e6cf35 100%);
  border: 1px solid rgba(250, 230, 60, 0.65);
  box-shadow: 0 4px 16px rgba(250, 230, 60, 0.22);
  color: #1a1a12;
}

.rule-btn--accept:active {
  filter: brightness(1.05);
}

@media (min-width: 400px) {
  .rule-hero__title {
    font-size: 1.25rem;
  }

  .rule-card__body {
    font-size: 0.8375rem;
  }
}
</style>
